<template>
  <read-article :article="foundArticles" />
</template>

<script>
import { externalBySlug } from '../../services/articles-service'

export default {
  name: 'ReadArticles',
  data () {
    return {
      foundArticles: {}
    }
  },
  async created () {
    this.foundArticles = await externalBySlug(this.$route.params.slug)
  }
}
</script>

<style scoped>

</style>
